import { ColorPickerField } from '../../components/ColorPickerField';

const emergencyBox2Plugin: any = {
  Renderer: ({ children, data }: any) => (
    <div className="emergency-box2-outer">
      <div
        className="emergency-box2"
        style={{
          border: `4px solid ${data?.style?.borderColor}`,
          display: 'flex',
          margin: '10px auto',
          padding: '20px',
          fontSize: '24px',
          borderRadius: '16px',
          justifyContent: 'center',
          alignItems: 'center',
          overflowWrap: 'anywhere',
          maxWidth: 300,
        }}
      >
        {data?.text}
      </div>
    </div>
  ),

  id: 'emergency-box2-plugin',
  title: 'Rounded Container',
  // description: 'Emergency Box2 element',
  version: 1,
  controls: [
    {
      title: 'Default Config',
      controls: {
        type: 'autoform',
        schema: {
          properties: {
            text: {
              type: 'string',
              default: 'Enter text...',
            },
          },
          required: ['text'],
        },
      },
    },
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                borderColor: {
                  type: 'string',
                  default: 'rgba(164, 186, 219,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Border Color: ',
                  },
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default emergencyBox2Plugin;
